import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import { ApplicationStateService } from '../../services/application-state.service';
import { environment } from '../../../environments/environment';
import { RouteService } from '../../services/route.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AssetService } from '../../services/asset.service';
import { BookFeatureActivationService } from '../../services/book-feature-activation.service';
import { FabricService } from '../../services/fabric.service';
import { ModalService } from '../../services/modal.service';
import { AbstractToolsBarComponent } from './abstract-tools-bar-component';
import { TooltipUtils } from '../../utils/tooltip-utils';
import { ZoomSliderComponent } from './zoom-slider/zoom-slider.component';
import { AssetPipe } from '../../pipes/asset.pipe';
import { DrawBarComponent } from './draw-bar/draw-bar.component';
import { PageSwitcherComponent } from '../footer/page-switcher/page-switcher.component';
import { ToolsBarDropUpComponent } from '../footer/mobile-tools-bar/tools-bar-drop-up/tools-bar-drop-up.component';
import { AccessibilityComponentDirective } from '../../directives/accessibility-component.directive';
import { BookFeatureService } from '../../services/book-feature.service';

@Component({
    selector: 'app-tools-bar',
    templateUrl: './tools-bar.component.html',
    styleUrls: ['./tools-bar.component.scss'],
    standalone: true,
    imports: [
        ZoomSliderComponent,
        AssetPipe,
        DrawBarComponent,
        PageSwitcherComponent,
        ToolsBarDropUpComponent,
        AccessibilityComponentDirective
    ]
})
export class ToolsBarComponent extends AbstractToolsBarComponent implements OnInit, AfterViewInit {

    isIOSSafari: boolean;
    isOnline: boolean;

    constructor(public applicationStateService: ApplicationStateService,
                public featureActivationService: BookFeatureActivationService,
                public assetService: AssetService,
                protected fabricService: FabricService,
                protected modalService: ModalService,
                protected communicationService: CommunicationService,
                private deviceService: DeviceDetectorService,
                private bookFeatureService:BookFeatureService,
                private routeService: RouteService) {
        super();
    }

    ngOnInit(): void {
        const deviceInfo = this.deviceService.getDeviceInfo();
        this.isIOSSafari = deviceInfo.browser === 'safari' && deviceInfo.device === 'iphone';
        this.isOnline = !this.applicationStateService.isOfflineModeEnabled;
    }

    ngAfterViewInit(): void {
        ($('[data-bs-toggle="tooltip"]') as any).tooltip(TooltipUtils.defaultTooltipConfig);
        ($('.dropdown-tooltip') as any).tooltip(TooltipUtils.defaultTooltipConfig);
    }

    /**
     * Get the url to the "copy to schoolbag" action.
     *
     * @returns {string}
     */
    getCopyToSchoolbagUrl(): string {
        return this.routeService.getAbsoluteRoute(environment.internalUrls.copyBook, {
            bookId: this.applicationStateService.bookId
        });
    }

    hideTooltipsAndCloseTools(): void {
        this.handleClosingTools();
        ($('.dropdown-tooltip') as any).tooltip('hide');
    }

    /**
     * controls whether BookViewer tools are closed when page downlaod is clicked.
     */
    handleClosingTools() {
        if (this.applicationStateService.pageEditMode?.type === 'DRAW' ||
            this.applicationStateService.pageEditMode?.type === 'SELECTION' ||
            this.applicationStateService.pageEditMode?.type === 'RECT') {
            this.bookFeatureService.dismissMode()
        }
    }
}
